import { HttpHandler } from 'msw'

import { createProfile } from './createProfile'
import { deleteProfile } from './deleteProfile'
import { getAllProfiles } from './getAllProfiles'
import { getProfile } from './getProfile'
import { permissions } from './permissions'
import { updateProfile } from './updateProfile'

export const profiles: HttpHandler[] = [
    createProfile,
    deleteProfile,
    getAllProfiles,
    getProfile,
    ...permissions,
    updateProfile,
]
